import React, { useEffect, useState } from 'react'
import { Button, Popover, Box, FormControl, MenuItem, Select, SelectChangeEvent, ListItemText, Checkbox } from "@mui/material";
import UpgradeDetails from './upgrade-details';
import { useTranslation } from 'react-i18next';


const Upgrade: React.FunctionComponent<{}> = (props) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const { t } = useTranslation();


    // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return (

        <>
            <Box>
                <a
                    // aria-describedby={id}
                    href='https://join-agents.coraly.ai/'
                    target='_blank'
                    className="upgrade-button disabled">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.9251 0.69754C13.9126 0.64129 13.8688 0.59754 13.8157 0.581915C11.9844 0.13504 7.75631 1.72879 5.46568 4.01942C5.05631 4.42567 4.68444 4.86629 4.35319 5.33504C3.64694 5.27254 2.94069 5.32567 2.33756 5.58817C0.63756 6.33504 0.14381 8.28817 0.00318504 9.12567C-0.02494 9.28817 0.0844351 9.44442 0.25006 9.47254C0.278185 9.47567 0.30631 9.47879 0.334435 9.47567L3.06256 9.17567C3.06569 9.38192 3.07819 9.58817 3.10006 9.79129C3.11256 9.93192 3.17818 10.0663 3.27818 10.1663L4.33443 11.2194C4.43443 11.3194 4.56881 11.385 4.70943 11.3975C4.91256 11.4194 5.11568 11.4319 5.32194 11.435L5.02193 14.16C5.00318 14.3257 5.12506 14.4757 5.29069 14.4913C5.31881 14.4944 5.34693 14.4944 5.37193 14.4882C6.20943 14.3538 8.16569 13.86 8.90944 12.16C9.17194 11.5569 9.22506 10.8538 9.16568 10.1507C9.63756 9.81942 10.0782 9.44442 10.4844 9.03817C12.7813 6.75379 14.3657 2.61942 13.9251 0.69754ZM10.3094 6.31004C9.72506 6.89441 8.77506 6.89754 8.19069 6.31004C7.60319 5.72567 7.60319 4.77567 8.19069 4.18817C8.77506 3.60067 9.72506 3.60067 10.3126 4.18817C10.8969 4.77567 10.8969 5.72567 10.3094 6.31004Z" fill="black" />
                        <path d="M4.2625 11.9819C4.09062 12.1538 3.81562 12.2194 3.48438 12.2788C2.74062 12.4038 2.08438 11.7632 2.21875 11.0132C2.26875 10.7288 2.42188 10.3288 2.51562 10.2351C2.56875 10.1819 2.57187 10.0944 2.51875 10.0413C2.4875 10.0101 2.44688 9.99444 2.40313 10.0007C1.9875 10.0507 1.6 10.2413 1.30625 10.5351C0.56875 11.2726 0.5 14.0007 0.5 14.0007C0.5 14.0007 3.23125 13.9319 3.96562 13.1944C4.2625 12.8976 4.45 12.5132 4.5 12.0944C4.5125 11.9663 4.35312 11.8882 4.2625 11.9819Z" fill="black" />
                    </svg>
                    {t('navbar.balanceCard.upgrade')}
                </a>

                {/* <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    anchorPosition={{ top: window.innerHeight / 2 - 200, left: window.innerWidth / 2 - 250 }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    PaperProps={{
                        sx: {
                            padding: 0,
                            overflow: "visible",
                            background: "#FFFFFF",
                            marginTop: "60px",
                            width: "auto",
                            boxShadow: " 0px 4px 48px rgba(0, 0, 0, 0.08)",
                            filter: "drop-shadow(0px 4px 48px rgba(0, 0, 0, 0.15))",
                            borderRadius: "12px",
                        },
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            backgroundColor: "white",
                            padding: "10px 5px",
                            borderRadius: "7px",
                            top: "-10px",
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: "-10px",
                                left: "50%",
                                width: "20px",
                                height: "0",
                                borderLeft: "10px solid transparent",
                                borderRight: "10px solid transparent",
                                borderBottom: "10px solid white",
                                transform: "translateX(-50%)",
                            }}
                        />
                        <div className="padd-20 mb-4 list-price" >
                            <UpgradeDetails />
                        </div>
                    </Box>
                </Popover> */}
            </Box>
        </>
    )
}

export default Upgrade